import { render, staticRenderFns } from "./PartnerAppView.vue?vue&type=template&id=85aaafca"
import script from "./PartnerAppView.vue?vue&type=script&lang=js"
export * from "./PartnerAppView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports